import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';
import { SourceSurveyEnum } from '../../defs/api';

export class SourceSurveyStore {
    rootStore: RootStore;

    isOpened: boolean = false;

    loading = false;

    source: SourceSurveyEnum | null = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    async updateSourceSurvey(): Promise<void> {
        if (!this.source) {
            return;
        }

        this.startLoading();

        try {
            await this.rootStore.apiClient.userController.userControllerUpdateSourceSurvey({
                sourceSurveyDto: {
                    sourceSurvey: this.source,
                },
            });
            await this.rootStore.authStore.fetchUserProfile();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            this.rootStore.alertStore.setErrorMessageByStatus(e.message);
        } finally {
            this.stopLoading();
            this.closeDialog();
        }
    }

    openDialog(): void {
        this.isOpened = true;
        this.rootStore.alertStore.setModalPlacement();
    }

    closeDialog(): void {
        this.isOpened = false;
        this.rootStore.alertStore.setDefaultPlacement();
    }

    setSource(source: SourceSurveyEnum | null): void {
        this.source = source;
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }
}
